import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
import styled from "styled-components";
export var FilterBannerContent = function(param) {
    var title = param.title, message = param.message, icon = param.icon, ctaText = param.ctaText, ctaOnClick = param.ctaOnClick;
    return /*#__PURE__*/ _jsxs(Wrapper, {
        children: [
            icon ? /*#__PURE__*/ _jsx(Column, {
                style: {
                    marginRight: "".concat(getSpacing("2x")),
                    alignSelf: "center"
                },
                children: icon
            }) : null,
            /*#__PURE__*/ _jsxs(Column, {
                style: {
                    alignItems: "baseline"
                },
                children: [
                    title ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraphSansMedium",
                                children: title
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraphSansRegular",
                                children: message
                            })
                        ]
                    }) : /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraphSansMedium",
                        children: message
                    }),
                    ctaText ? /*#__PURE__*/ _jsx(Button, {
                        style: {
                            marginTop: "".concat(getSpacing("1x"))
                        },
                        variant: "tertiary",
                        onClick: ctaOnClick,
                        children: ctaText
                    }) : null
                ]
            })
        ]
    });
};
// eslint-disable-next-line @faire/prefer-slate-attrs -- use ResponsiveContentV2
var Wrapper = styled(Row).attrs({
    align: "baseline"
}).withConfig({
    componentId: "sc-da60067e-0"
})([
    "padding-top:",
    ";padding-bottom:",
    ";&:empty{display:none;}"
], getSpacing("1x"), getSpacing("1x"));
